import { BLOCK_CLASSES as a } from "../../constants.js";
import { defineAttrs as o } from "../../utils/typed-attrs.js";
import { stylable as l } from "../decorators/stylable.js";
import { getBackgroundColor as n } from "./spec-util.js";
const i = ["true", "false"], c = (t, e) => e ? t.concat(e, ";") : "", s = (t) => ({
  paddingTop: t.style?.paddingTop,
  paddingBottom: t.style?.paddingBottom,
  paddingLeft: t.style?.paddingLeft,
  paddingRight: t.style?.paddingRight,
  backgroundColor: n(t.style?.backgroundColor),
  colwidth: t.getAttribute("data-colwidth") ? [Number(t.getAttribute("data-colwidth"))] : null
}), d = o({
  type: { default: "table" },
  responsive: { default: !1 },
  container: { default: !1 },
  stacked: { default: void 0 },
  sectionType: { default: void 0 },
  backgroundColor: { default: "" }
}), y = l({
  content: "tableRow+",
  tableRole: "table",
  isolating: !0,
  attrs: d,
  parseDOM: [
    {
      tag: "table",
      getAttrs(t) {
        return {
          responsive: t.getAttribute("data-responsive") !== null,
          // @ts-expect-error - data-stacked is not typed
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          stacked: i.includes(t.attributes["data-stacked"]) ? (
            // @ts-expect-error - data-stacked is not typed correctly
            t.attributes["data-stacked"]
          ) : !0,
          container: t.getAttribute("data-container") !== null,
          sectionType: t.getAttribute("data-section-type") ?? void 0,
          backgroundColor: n(t.style?.backgroundColor)
        };
      }
    }
  ],
  toDOM(t) {
    if (t.attrs.container) {
      const e = t.attrs, r = e.sectionType ?? "";
      return [
        "div",
        {
          class: `${a.blockContainer} ${a.table} embercom-prosemirror-composer-section`
        },
        ["div", { class: "section-type" }, r],
        [
          "table",
          {
            class: "container intercom-template-content",
            "data-container": "true",
            "data-section-type": r,
            style: `${c("background-color: ", e.backgroundColor ?? "")}`
          },
          ["tbody", 0]
        ]
      ];
    }
    return t.attrs.responsive ? [
      "div",
      {
        class: `${a.blockContainer} ${a.table} embercom-prosemirror-composer-layout`
      },
      [
        "table",
        {
          class: "row intercom-responsive-layout-table",
          "data-responsive": "true",
          "data-stacked": typeof t.attrs.stacked == "boolean" ? t.attrs.stacked.toString() : ""
        },
        ["tbody", 0]
      ]
    ] : [
      "div",
      {
        class: `${a.blockContainer} ${a.table}`
      },
      ["table", ["tbody", 0]]
    ];
  }
}), k = {
  content: "tableCell+",
  tableRole: "row",
  parseDOM: [{ tag: "tr" }],
  toDOM() {
    return ["tr", 0];
  }
}, u = o({
  colspan: { default: 1 },
  rowspan: { default: 1 },
  colwidth: { default: null },
  responsiveClasses: { default: "" },
  container: { default: !1 }
}), C = l({
  content: "(block | list)+",
  tableRole: "cell",
  isolating: !0,
  parseDOM: [
    {
      tag: "td",
      getAttrs(t) {
        return s(t);
      }
    },
    {
      tag: "th",
      getAttrs(t) {
        return s(t);
      }
    }
  ],
  attrs: u,
  toDOM(t) {
    const e = t.attrs;
    return t.attrs.responsiveClasses ? ["td", { "data-insertable": "true", class: e.responsiveClasses }, 0] : ["td", { "data-insertable": "true", "data-colwidth": e.colwidth?.[0] ?? null ?? void 0 }, 0];
  }
});
export {
  C as tableCellSpec,
  k as tableRowSpec,
  y as tableSpec
};
